import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http, settings } from '../../utils/config';

const initialState = {
    categoryTiktok: null,
    isLoadCategory: false,
    brandsTiktok: [],
    isLoadBrands: false,
}
export const getCateGoryTikTok = createAsyncThunk(
    'TikTok/getCateGoryTikTok',
    async () => {
        const shopCipher = settings.getCookie("shop_cipherTikTok");
        const response = await http.get(
            `/get-category-tiktok?shop_cipher=${shopCipher}&category_version=v2`
        );
        return response.data.data;
    }
);

/**
 * @param {Object} [opts] - optional: { category_id, category_version }
 */
export const getBrandsTikTok = createAsyncThunk(
    'TikTok/getBrandsTikTok',
    async (opts) => {
        const shopCipher = settings.getCookie("shop_cipherTikTok");
        const params = new URLSearchParams({ shop_cipher: shopCipher });
        if (opts?.category_id) params.set('category_id', opts.category_id);
        if (opts?.category_version) params.set('category_version', opts.category_version);
        const response = await http.get(`/get-brand-tiktok?${params.toString()}`);
        return response.data.data;
    }
);

const getCateGory = createSlice({
    name: "getCateGory",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCateGoryTikTok.pending, (state) => {
                state.isLoadCategory = true;
            })
            .addCase(getCateGoryTikTok.fulfilled, (state, action) => {
                state.categoryTiktok = action.payload
                state.isLoadCategory = false;
            })
            .addCase(getCateGoryTikTok.rejected, (state, action) => {
                state.isLoadCategory = false;
            })
            .addCase(getBrandsTikTok.pending, (state) => {
                state.isLoadBrands = true;
            })
            .addCase(getBrandsTikTok.fulfilled, (state, action) => {
                state.brandsTiktok = action.payload ?? [];
                state.isLoadBrands = false;
            })
            .addCase(getBrandsTikTok.rejected, (state) => {
                state.isLoadBrands = false;
            });
    },
});

export default getCateGory.reducer